import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@material-ui/core";

const UpdateDisplayName = ({
  action,
  open,
  row,
  value,
  onChange,
  onSave,
  onClose,
  loading = false,
  label = "Display Name",
  placeholder = "Enter display name",
  title = "Title",
}) => {
  const generateDescription = ({ action, row }) => {
    const sensorName = row.sensor_display_name || row.id || row.length;

    if (action === "rename") {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 24 }}
        >
          Provide a custom display name for the sensor :{" "}
          <strong>{sensorName}</strong> across the application.
        </Typography>
      );
    }
    if (action === "assign") {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 24 }}
        >
          Assign sensor: Do you want to assign the sensor :{" "}
          <strong>{sensorName}</strong> to the selected facility ?
        </Typography>
      );
    }
    if (action === "unassign") {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 24 }}
        >
          Unassign sensor: Do you want to unassign the sensor :{" "}
          <strong>{sensorName}</strong> from the facility ?
        </Typography>
      );
    }
    if (action === "bulkunassign") {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 24 }}
        >
          Bulk Unassign sensor: Do you want to unassign{" "}
          <strong>{sensorName}</strong> selected sensor(s) from the facility ?
        </Typography>
      );
    }
    if (action === "bulkassign") {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 24 }}
        >
          Bulk Assign sensor: Do you want to assign{" "}
          <strong>{sensorName}</strong> selected sensor(s) to the facility ?
        </Typography>
      );
    }
    if (action === "enable") {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 24 }}
        >
          Enable Attribute for the sensor: Do you want to enable{" "}
          <strong>{sensorName}</strong> attribute for the sensor ?{" "}
        </Typography>
      );
    }
    if (action === "disable") {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 24 }}
        >
          Disable Attribute for the sensor: Do you want to disable{" "}
          <strong>{sensorName}</strong> attribute for the sensor ?{" "}
        </Typography>
      );
    }
    if (action === "bulkenable") {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 24 }}
        >
          Bulk Enable Attribute(s) for the sensor: Do you want to eanble{" "}
          <strong>{sensorName}</strong> attribute(s) for the sensor ?{" "}
        </Typography>
      );
    }
    if (action === "bulkdisable") {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 24 }}
        >
          Bulk Disable Attribute(s) for the sensor: Do you want to disable{" "}
          <strong>{sensorName}</strong> attribute(s) for the sensor ?{" "}
        </Typography>
      );
    }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        {row &&
          generateDescription({
            action: action,
            row: row,
          })}

        {(action === "assign" ||
          action == "unassign" ||
          action === "rename" ||
          action === "enable") && (
          <TextField
            autoFocus
            fullWidth
            label={label}
            placeholder={placeholder}
            variant="standard"
            value={value}
            style={{ marginTop: "10px" }}
            onChange={(e) => onChange(e.target.value)}
            InputProps={{
              readOnly: action !== "rename",
            }}
          />
        )}
      </DialogContent>

      <DialogActions style={{ padding: 16 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>

        <Button
          color="primary"
          variant="contained"
          onClick={onSave}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateDisplayName;
